import React, { useState } from "react";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface TableThumbnailProps {
  src?: string;
  alt?: string;
}

export function TableThumbnail({ src, alt = "" }: TableThumbnailProps) {
  const [open, setOpen] = useState(false);

  if (!src) return <Box sx={{ p: 0.5, width: 100, height: 50 }} />;

  return (
    <>
      <Box
        sx={{ p: 0.5, border: 1, borderColor: "grey.300", borderRadius: 1, width: 100, overflow: "hidden", cursor: "pointer" }}
        onClick={() => setOpen(true)}
      >
        <img
          src={src}
          alt={alt}
          style={{ width: "100%", height: "auto", maxHeight: 50, objectFit: "contain", display: "block" }}
        />
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <IconButton
          onClick={() => setOpen(false)}
          sx={{ position: "absolute", top: 8, right: 8, bgcolor: "rgba(0,0,0,0.5)", color: "#fff", "&:hover": { bgcolor: "rgba(0,0,0,0.7)" } }}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <DialogContent sx={{ p: 1 }}>
          <img src={src} alt={alt} style={{ width: "100%", height: "auto", display: "block" }} />
        </DialogContent>
      </Dialog>
    </>
  );
}
